'use client';

import React, { useState } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { AlertTriangle, X } from 'lucide-react';

export default function WarningBanner() {
	const { user } = useAuth();
	const [dismissed, setDismissed] = useState(false);

	if (!user || dismissed) return null;

	// 1. Check for Disabled State (Highest Priority)
	if (user.isDisabled) {
		return (
			<div className="fixed top-16 left-0 right-0 z-50 bg-red-600 text-white px-4 py-3 shadow-md animate-in slide-in-from-top-2">
				<div className="max-w-7xl mx-auto flex items-start gap-3 pr-8">
					<AlertTriangle className="w-5 h-5 flex-shrink-0 mt-0.5" />
					<div>
						<p className="font-bold text-sm">Account Disabled</p>
						<p className="text-sm opacity-90">
							Your account has been disabled. You cannot make purchases or perform actions. Please contact support.
						</p>
					</div>
				</div>
				<button
					onClick={() => setDismissed(true)}
					className="absolute top-2 right-2 p-1.5 hover:bg-red-700 rounded-lg transition-colors"
				>
					<X className="w-4 h-4" />
				</button>
			</div>
		);
	}

	// 2. Check for Warnings
	if (user.warnings && user.warnings.length > 0) {
		const latestWarning = user.warnings[user.warnings.length - 1];
		return (
			<div className="fixed top-16 left-0 right-0 z-50 bg-orange-600 text-white px-4 py-3 shadow-md animate-in slide-in-from-top-2">
				<div className="max-w-7xl mx-auto flex items-start gap-3 pr-8">
					<AlertTriangle className="w-5 h-5 flex-shrink-0 mt-0.5" />
					<div>
						<p className="font-bold text-sm">Action Required</p>
						<p className="text-sm opacity-90">{latestWarning.message}</p>
						<p className="text-[10px] opacity-75 mt-1">
							{new Date(latestWarning.date).toLocaleDateString()}
						</p>
					</div>
				</div>
				<button
					onClick={() => setDismissed(true)}
					className="absolute top-2 right-2 p-1.5 hover:bg-orange-700 rounded-lg transition-colors"
				>
					<X className="w-4 h-4" />
				</button>
			</div>
		);
	}

	return null;
}
